import { useEffect, useState } from 'react';
import { SiteAnnouncement } from 'core/siteAnnouncement/SiteAnnouncement';
import { Redirect } from 'react-router-dom';
import { useCoreContext } from 'contexts/coreContext';
import { DefaultSiteAnnouncementManager } from 'core/siteAnnouncement/SiteAnnouncementManager';
import { useCallAPI } from 'hooks/useCallAPI';

const siteAnnouncementManager = new DefaultSiteAnnouncementManager();

export const RedirectAnnouncement: React.FC = () => {
  const [announcement, setAnnouncement] = useState<SiteAnnouncement>();

  const core = useCoreContext();
  const { callAPIs } = useCallAPI();

  const authenticationManager = core?.authenticationManager;
  const agencyId = core?.accountManager.localeMeta?.agencyId;

  useEffect(() => {
    if (!authenticationManager || !agencyId) {
      setAnnouncement(undefined);
      return;
    }

    callAPIs(
      [() => siteAnnouncementManager.getTopAnnouncement(agencyId)],
      (announcement: SiteAnnouncement | undefined) => {
        if (!announcement) {
          setAnnouncement(undefined);
          return;
        }

        const readContent =
          authenticationManager.hasReadAnnouncement(announcement);
        !readContent && setAnnouncement(announcement);
      }
    );
  }, [authenticationManager, agencyId, callAPIs]);

  if (!announcement) {
    return null;
  }

  return (
    <Redirect
      to={{
        pathname: '/site-announcements',
        state: { autoOpenAnnouncementId: announcement.id }
      }}
    />
  );
};
